module.exports = __webpack_public_path__ + "static/media/lead-source-icon.97f72f95.svg";